// extracted by mini-css-extract-plugin
export default {"mainIcon":"PintrestShareLink_mainIcon__5MDzV"};